import { useEffect, useRef } from 'react'
import styles from './AllAboutUs.module.css'

const AllAboutUs = () => {
  const sectionRef = useRef(null)

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.visible)
          }
        })
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    )

    const elements = sectionRef.current?.querySelectorAll(`.${styles.reveal}`)
    elements?.forEach((el) => observer.observe(el))
    return () => observer.disconnect()
  }, [])

  return (
    <section className={styles.section} ref={sectionRef}>
      {/* Intro */}
      <div className={styles.introBlock}>
        <div className={`${styles.introInner} ${styles.reveal}`}>
          <span className={styles.sectionLabel}>Our Story</span>
          <h2 className={styles.introHeading}>
            Established in 2012, with over 14 years of experience in the HVAC industry, we are a trusted solutions partner for commercial and corporate environments.
          </h2>
        </div>
      </div>

      {/* Body copy */}
      <div className={styles.bodyBlock}>
        <div className={`${styles.bodyCol} ${styles.reveal}`}>
          <p className={styles.bodyText}>
            Our expertise spans across system planning, product selection, professional installation, and ongoing maintenance—ensuring optimal performance and long-term reliability.
          </p>
        </div>
        <div className={`${styles.bodyCol} ${styles.reveal}`}>
          <p className={styles.bodyText}>
            Driven by deep industry knowledge and a commitment to quality, we focus on creating efficient, worry-free HVAC systems that support modern workplaces.
          </p>
        </div>
      </div>

      {/* Divider */}
      <div className={styles.divider}>
        <span className={styles.dividerLine} />
      </div>

      {/* Vision & Mission */}
      <div className={styles.vmBlock}>
        <div className={`${styles.vmCard} ${styles.reveal}`}>
          <div className={styles.vmIconWrap}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <circle cx="12" cy="12" r="6" />
              <circle cx="12" cy="12" r="2" />
            </svg>
          </div>
          <h3 className={styles.vmTitle}>Our Vision</h3>
          <p className={styles.vmText}>
            To be one of the leading provider of innovative and sustainable HVAC solutions, enhancing comfort and efficiency for homes and businesses nationwide.
          </p>
        </div>
        <div className={`${styles.vmCard} ${styles.reveal}`}>
          <div className={styles.vmIconWrap}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
              <polyline points="22 4 12 14.01 9 11.01" />
            </svg>
          </div>
          <h3 className={styles.vmTitle}>Our Mission</h3>
          <p className={styles.vmText}>
            Our mission is to deliver superior HVAC solutions, ensuring customer satisfaction through quality workmanship, cutting-edge technology, and a commitment to delivering a sustainable and efficient result.
          </p>
        </div>
      </div>

      {/* Founder */}
      <div className={`${styles.founderBlock} ${styles.reveal}`}>
        <div className={styles.founderInner}>
          <div className={styles.founderQuoteMark}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor" opacity="0.15">
              <path d="M4.583 17.321C3.553 16.227 3 15 3 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179zm10 0C13.553 16.227 13 15 13 13.011c0-3.5 2.457-6.637 6.03-8.188l.893 1.378c-3.335 1.804-3.987 4.145-4.247 5.621.537-.278 1.24-.375 1.929-.311 1.804.167 3.226 1.648 3.226 3.489a3.5 3.5 0 0 1-3.5 3.5c-1.073 0-2.099-.49-2.748-1.179z" />
            </svg>
          </div>
          <h3 className={styles.founderLabel}>From the Founder</h3>
          <blockquote className={styles.founderQuote}>
            From a young age, I was inspired by my father, who was himself into the HVAC industry. His passion and dedication instilled in me a love for this field. Witnessing the evolution and growing importance of HVAC systems in both domestic and commercial spaces, I was determined to contribute meaningfully to this essential industry.
          </blockquote>
          <p className={styles.founderContinued}>
            With over 14 years of experience, our company is committed to setting new standards in design, sales, installation, and maintenance of HVAC systems. We strive for excellence, driven by deep industry knowledge and a legacy of passion.
          </p>
        </div>
      </div>
    </section>
  )
}

export default AllAboutUs
